<!--
 * @Author: your name
 * @Date: 2021-03-02 10:08:25
 * @LastEditTime: 2021-06-22 14:58:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \leading\newVersionEdingzi\src\App.vue
-->
<template>
  <div id="app">
    <transition
      name="fade"
      mode="out-in"
      appear
    >
      <keep-alive
        :max="1"
        :include="keepAlive"
      >
        <router-view />
      </keep-alive>
    </transition>
    <weChat
      v-if="weChatBool"
      @colseWeChat="weChatBool=false"
    ></weChat>

    <temFoot v-if="!footBool"></temFoot>
  </div>
</template>

<script>
import temFoot from "@/views/public/foot.vue";
import weChat from "@/views/public/weChat.vue";

export default {
  name: "App",
  components: {
    temFoot,
    weChat,
  },
  data() {
    return {
      weChatBool: false,
      footBool:
        this.$route.meta.footBool === true ? this.$route.meta.footBool : false,
    };
  },
  computed: {
    keepAlive() {
      return this.$store.state.keepAlive;
    },
    key() {
      return this.$route.path;
    },
  },
  created() {},
  watch: {
    $route(to, from) {
      // console.log(this.$route.meta.footBool)//路由配置  this.$route.meta.footBool
      if (this.$route.meta.footBool === true) {
        this.footBool = true; //底部不可见
      } else {
        this.footBool = false; //底部可见
      }
    },
  },
  mounted() {
    if (!window.sessionStorage.getItem("bclosingBit")) {
      window.sessionStorage.clear();
    }
  },
};
</script>
<style scoped>
/* 过度动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue